<template>
  <div class="title">
    <!-- <div class="bor">
      <img src="../assets/imgs/project/normal_dot.png" alt />
    </div> -->
    <span></span>
    <p>{{til}}</p>
  </div>
</template>

<script>
export default {
  props: ["til"]
};
</script>

<style scoped lang='less'>
.title {
  height: 24px;
  span{
    float: left;
    margin-top: 4px;
    width: 5px;
    height: 16px;
    background: #0290FD;
    margin-left: 35px;
    margin-right: 11px;
    display: inline-block;
  }
  p {
    width: 130px;
    // height: 23px;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    text-align: left;
  }
  .bor {
    width: 14px;
    height: 14px;
    // border: 2px solid rgba(57, 139, 241, 1);
    // border-radius: 50%;
    float: left;
    margin-right: 15px;
    img {
      vertical-align: middle;
      height: 100%;
      width: 100%;
    }
  }
}
</style>